import React, { Component } from "react";
import { Row, Col, Icon, Tooltip } from "antd";
const text1 = <span>更换图片</span>;
const text2 = <span>删除图片</span>;
const text3 = <span>拖动排序</span>;

export default class EditorItem extends Component {
  constructor(props) {
    super(props);
    this.state={}
  }
  render() {
    return (
      <div
        style={{
          padding: "10px",
          rgba: "0 0 0 0.1",
        }}
      >
        <Row
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Col span={3}>
            <div className="atlasListPic">
              <img src={this.props.path} alt="" />
            </div>
          </Col>
          <Col span={12} style={{ textAlign: "center", color: "#000" }}>
            <textarea
              style={{
                resize: "none",
                width: "500px",
                height: "100px",
                border: "0",
                backgroundColor: "#fff",
                padding: "10px 0px 0px 20px",
              }}
            >
              {this.props.desc}
            </textarea>
          </Col>
          <Col span={3} style={{ textAlign: "center" }}>
            <Tooltip placement="top" title={text1}>
              <Icon type="file-image" />
            </Tooltip>
          </Col>
          <Col
            span={3}
            style={{ textAlign: "center" }}
            onClick={() => this.props.myClick()}
          >
            <Tooltip placement="top" title={text2}>
              <Icon type="delete" />
            </Tooltip>
          </Col>
          <Col span={3} style={{ textAlign: "center" }}>
            <Tooltip placement="top" title={text3}>
              <Icon type="unordered-list" />
            </Tooltip>
          </Col>
        </Row>
      </div>
    );
  }
}
